import client from '../client';

export default {
  getCampaignList: (data) =>
    client.get('publisher/cc/campaigns/list', { params: data }).then((res) => res.data),
  
  getBonusProgramList: (data) =>
    client.get('publisher/cc/bonus/programs/list', { params: data }).then((res) => res.data),
  getBonusProgramDetail: (data) =>
    client
      .get(`publisher/cc/bonus/programs/${data.programId}`, { params: data })
      .then((res) => res.data),
  getBonusProgramCampaigns: (data) =>
    client
      .get(`publisher/cc/bonus/programs/${data.programId}/campaigns`, { params: data })
      .then((res) => res.data),

  getBonusProgramProducts: (data) =>
    client
      .get(`publisher/cc/bonus/programs/${data.programId}/products`, { params: data })
      .then((res) => res.data),
  getBonusProgramTierRates: (data) =>
    client
      .get(`publisher/cc/bonus/programs/${data.programId}/tier-rates`, { params: data })
      .then((res) => res.data),
  getPopActive: data => {
    return client.get('publisher/popups/active', {params:data}).then(res => res.data);
  },
  getBonusProgramCampaignProducts: (data) =>
    client
      .get(`publisher/cc/bonus/programs/${data.programId}/campaigns/${data.campaignId}/products`, { params: data })
      .then((res) => res.data),
};
